import React from 'react';
import Table from '../Table';

const title = "Other Details";
const columns = [
	{
		name: 'Low Balance 1',
		selector: 'lowBalAmt1',
		sortable: false,
	},
	{
		name: 'Low Balance 2',
		selector: 'lowBalAmt2',
		sortable: false
	},
	{
		name: 'Low Balance 3',
		selector: 'lowBalAmt3',
		sortable: false
	},
	{
		name: 'Low Balance 4',
		selector: 'lowBalAmt4',
		sortable: false
	},
	{
		name: 'Large Credit',
		selector: 'largeCreditAmt',
		sortable: false
	}
];

function MiscInfoTable(props) {
	return (
		<Table title={title} columns={columns} data={props.data} pagination={false} />
	);
}

export default MiscInfoTable;